<div *ngIf="photoId!=null && additioanl==false" class="view-photo">
  <div class="view-photo__content">
    <h3>{{photoTitle}}</h3>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup" style="float: right;">close</i>
    <div class="photo-comment">{{photoComment}}</div>
    <button mat-raised-button (click)="openEditPhoto()">Edit Photo</button>
    <button mat-raised-button *ngIf="(isMP || isMandatoryPhoto) && isDeleteAllowed" (click)="showDeletePhotoConfirmationDialog()">Delete Photo</button>
  </div>
  <div class="view-photo__photo">
    <img *ngIf="photoData != null" [src]="getImage(photoData)" />
  </div>
</div>

<div *ngIf="photoId==null && additioanl==false" class="view-photo">
  <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup" style="float: right;">close</i>
  <div>
    <img *ngIf="photoData != null" [src]="getImage(photoData)" />
  </div>
</div>

<!-- <div *ngIf="photoId!=null && additioanl==true" class="view-photo">
  <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup" style="float: right;">close</i>
  <div>
    <img *ngIf="photoData != null" [src]="getImage(photoData)" />
  </div>
</div> -->

<div *ngIf="photoId!=null && additioanl==true" class="view-photo">
  <div class="view-photo__content">
  <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup" style="float: right;">close</i>
  <button mat-raised-button (click)="openEditPhoto()">Edit Photo</button>
  <button mat-raised-button (click)="showDeletePhotoConfirmationDialog()">Delete Photo</button>
</div>
  <div class="view-photo__photo">
    <img *ngIf="photoData != null" [src]="getImage(photoData)" />
  </div>
</div>